<template>
  <v-app class='app'>
    <Loader :value="loading" progressColor="white" :message="loaderMessage" :nextMessage="loaderTriggerNext" />
    <v-app-bar app id="app-toolbar" elevation=1 collapse-on-scroll>
        <v-layout align-center>
          <v-btn icon @click="menu = !menu">
            <v-icon color="primary"> mdi-menu</v-icon>
          </v-btn>
          <v-toolbar-title @click="$router.push('/')" >
            Red Sky Designs Catalog
            <!-- <v-img :src=toolbarImg id=toolbar-img @click="$router.push('/')" /> -->
          </v-toolbar-title>
          <v-spacer />
          <div id="cart-box" v-if="$route.name =='Catalog' || myProducts.length > 0 " >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn large icon rounded v-on="on" @click="$router.push('/order')">
                  <v-icon large color="primary"> mdi-view-list</v-icon>
                </v-btn>
              </template>
              <span>View Order</span>
            </v-tooltip>
            <span class='title'>
              {{myProducts.length}}
            </span>
          </div>
           
        </v-layout>
    </v-app-bar>
    
    <CoreDrawer :control="menu" :list="items" :isLogged="isLogged" @update="menu = $event;" @signout="$store.dispatch('userSignOut')" />
    <CoreView id='views'/>
    <CoreFooter />
    <CoreNotification :color="$vuetify.theme.themes.light.primary" :message="notifyMessage" :timeout="notifyTimeout" @update="notify = $event" />
  </v-app>
</template>

<script>

import {
  mapGetters
} from 'vuex'

export default {
  name: 'App',
  // components: {
  //   HelloWorld,
  // },
  created: function() {
    let position = this.$localStorage.get('genericLoaderPosition')
    this.genericLoaderPosition = position ? position : 0

  },
  data: () => ({

    toolbarImg: require('@/assets/banner-logo.png'),
    menu: false,
    items: [
      {title: 'Home', icon: 'mdi-home', path: '/', requiresAuth: false},
      // {title: 'Sign In', icon: 'mdi-lock', path: '/', requiresAuth: false},
      {title: 'Catalog', icon: 'mdi-book-open-page-variant', path: 'catalog', requiresAuth: true},
      {title: 'View order', icon: 'mdi-view-list', path: 'order', requiresAuth: true},
      {title: 'Order history', icon: 'mdi-history', path: '/', requiresAuth: true},

    ],
    loaderTriggerNext: true,
    loaderMessage: 'Warming up in the sun',
    genericLoaderPosition: 0,
    genericLoader: [
      'Packing the towels...',
      'Putting on sunscreen...',
      'Tightening Sandles...',
      'Inflating Beachball...',
      'Adjusting Sunglasses...',
      'Packing Picnic...',
      'Opening Umbrella...',
      'Grabbing Floaties...',
      'Cleaning out the sand...',
      'Finding keys...',
      'Loading the car...',
      'Adding salt...',
      'Pouring a lemonade...',
      'Getting on paddleboard...',
    ],
    loaderDriver: null,
  }),
  computed: {
    ...mapGetters({
      debug: 'getDebug',
      loading: 'getLoading',
      isLogged: 'getIsLogged',
      myProducts: 'getThisOrder',
      notifyMessage: 'getNotifyMessage',
      notifyTimeout: 'getNotifyTimeout',
      menuControl: 'getMenuControl'
    })
  },
  watch: {
    loading: {
      handler(newVal, oldVal) {
        let self = this
        function doer() {
          self.loaderTriggerNext = false
          setTimeout(() => {
            self.genericLoaderPosition++
            if(self.genericLoaderPosition < self.genericLoader.length) {
              self.loaderMessage = self.genericLoader[self.genericLoaderPosition]
              self.genericLoaderPosition++
            } else {
              self.genericLoaderPosition = 0;
              self.loaderMessage = self.genericLoader[self.genericLoaderPosition]
            }
            self.loaderTriggerNext = true
            self.$localStorage.set('genericLoaderPosition', self.genericLoaderPosition)
          }, 1500)
        }
        if(newVal != oldVal && newVal) {
          doer()
          this.loaderDriver = setInterval(doer, 3000);
        } else {
          if(this.loaderDriver) clearInterval(this.loaderDriver)
        }
      }
    },
    menuControl: {
      handler(newVal, oldVal) {
        if(newVal != oldVal) {
          this.menu = newVal
        }
      }
    }
  }
};
</script>

<style>

  /*  I was tired of text defaulting to all caps on buttons */
  .v-btn {
    text-transform:none !important;
  }

  /*  Hides the recaptcha badge so it doesn't show up, must have notice to users if it is hidden 
      https://stackoverflow.com/questions/44543157/how-to-hide-the-google-invisible-recaptcha-badge
  */
  .grecaptcha-badge { 
    visibility: hidden;
  }

</style>

<style scoped>

  #toolbar-img {
      width: 30vw;
      max-width: 150px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-right: -50%;
      transform: translate(-50%, -50%);
  }

  #views {
    width: 100vw;
  }

  #cart-box {
    border-style: solid;
    border-radius: 10px;
    border-width: 2px;
    border-color: #eeeeee;
    padding: 3px;
    padding-left: 5px;
    padding-right: 7px;

  }

</style>
